import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { fetchOkendoReviews } from '../../api/okendo';
import { okendoReviewsJsonLD } from './okendo-jsonld';

const OkendoWidget = styled('div')`
  overflow-x: hidden;
  * {
    font-family: 'Exo 2', sans-serif !important;
    font-size: 17px !important;
  }
`;

const OkendoReviews = ({ reviewsBy, id }) => {
  const widgetContainer = useRef(null);
  const [reviews, setReviews] = useState({});

  const widgetAttribute = {
    all: {},
    group: { 'data-oke-reviews-group-id': id },
    product: { 'data-oke-reviews-product-id': `shopify-${id}` },
  };

  const initialiseWidget = () => {
    window.okeWidgetApi.initWidget(widgetContainer.current);
  };

  useEffect(() => {
    (async () => {
      const okendoReviews = await fetchOkendoReviews(reviewsBy, id);
      setReviews(okendoReviews);
    })();

    if (window.okeWidgetApi?.initWidget) {
      initialiseWidget();
    } else {
      window.addEventListener('oke-script-loaded', initialiseWidget);
    }
    return () => {
      document.removeEventListener('oke-script-loaded', initialiseWidget);
    };
  }, [reviewsBy, id]);

  const compiledJSONLD =
    Object.keys(reviews).length > 0 ? okendoReviewsJsonLD(reviews) : '';

  return (
    <>
      {compiledJSONLD.length > 0 ? (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: compiledJSONLD,
          }}
        />
      ) : null}
      <OkendoWidget
        className='okendo-reviews'
        ref={widgetContainer}
        data-oke-widget
        {...widgetAttribute[reviewsBy]}
      />
    </>
  );
};

OkendoReviews.propTypes = {
  reviewsBy: PropTypes.string,
  id: PropTypes.string,
};

OkendoReviews.defaultProps = {
  reviewsBy: 'all',
  id: '0',
};

export default OkendoReviews;
